import script from "./FeedBack.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedBack.vue?vue&type=script&setup=true&lang=js"

import "./FeedBack.vue?vue&type=style&index=0&id=42ec4cd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ec4cd2"]])

export default __exports__